const ENCODED_PREFIX = "b64:";
const BASE64_PATTERN =
  /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;

export function encodeEventDescription(description: string): string {
  if (!description) return "";

  const bytes = new TextEncoder().encode(description);
  const binary = Array.from(bytes, (byte) => String.fromCharCode(byte)).join(
    "",
  );
  return `${ENCODED_PREFIX}${btoa(binary)}`;
}

export function decodeEventDescription(description: string): string {
  if (!description.startsWith(ENCODED_PREFIX)) return description;

  const encoded = description.slice(ENCODED_PREFIX.length);
  if (!encoded || !BASE64_PATTERN.test(encoded)) return description;

  try {
    const bytes = Uint8Array.from(atob(encoded), (character) =>
      character.charCodeAt(0),
    );
    return new TextDecoder("utf-8", { fatal: true }).decode(bytes);
  } catch {
    return description;
  }
}
